import { lazy, Suspense } from "react";
import { Route, Routes, useNavigate } from "react-router";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "../Components/ErrorFallback";
import SuspenseFallback from "../Components/SuspenseFallback";

const TestSeriesRoute = lazy(
  () => import("src/Modules/ExamModule/Routes/TestSeriesRoute")
);
const MockTestRuleManagement = lazy(
  () => import("src/Modules/ExamModule/Routes/MockTestRuleManagement")
);
const AddMockTestRuleRoute = lazy(
  () => import("src/Modules/ExamModule/Routes/AddMockTestRuleRoute")
);
const EditMockTestRuleRoute = lazy(
  () => import("src/Modules/ExamModule/Routes/EditMockTestRuleRoute")
);
const MockTestGenerationRoute = lazy(
  () => import("src/Modules/ExamModule/Routes/MockTestGenerationRoute")
);

export type AppRouteParams = {
  "/:testSeriesId/:testSeriesExamTestTypeId": {
    testSeriesId: string;
    testSeriesExamTestTypeId: string;
  };
};

function AppRouter() {
  const navigate = useNavigate();

  return (
    <Routes>
      {/* Mock test rules routes */}
      <Route path="/mock-test-rules" element={<MockTestRuleManagement />} />
      <Route path="/mock-test-rules/add" element={<AddMockTestRuleRoute />} />
      <Route
        path="/mock-test-rules/edit/:id"
        element={<EditMockTestRuleRoute />}
      />

      {/* Mock test generation route */}
      <Route
        path="/mock-test-generation"
        element={<MockTestGenerationRoute />}
      />
      <Route
        path="/:testSeriesId/:testSeriesExamTestTypeId"
        element={
          <ErrorBoundary
            fallbackRender={() => <ErrorFallback />}
            onReset={() => navigate("/")}
          >
            <Suspense fallback={<SuspenseFallback />}>
              <TestSeriesRoute />
            </Suspense>
          </ErrorBoundary>
        }
      />
    </Routes>
  );
}

export default AppRouter;
